module.exports = __webpack_public_path__ + "static/media/play-store-cache.2ba12f79.png";